import {MediumApiService} from "./medium.api.service";
import {NgModule} from "@angular/core";
import {StoreModule} from "@ngrx/store";
import {mediumInitialState, mediumReducer, IMediumState} from "./medium.reducer";
import {mediumFeatureKey} from "./types";
import {EffectsModule} from "@ngrx/effects";
import {MediumEffects} from "./medium.effects";
import {MediumService} from "./medium.service";

@NgModule({
    imports:[
        StoreModule.forFeature<IMediumState>(mediumFeatureKey, mediumReducer, {
            initialState: mediumInitialState,
        }),
        EffectsModule.forFeature([MediumEffects])
    ],
    providers:[MediumApiService, MediumService]
})
export class StoreMediumModule {}
